<template>
  <Userlanding>
    <a-spin style="width: 100%; min-height: 80vh" :spinning="spin">
      <Account v-if="currentStep == 0" :handleCreate="handleCreateAccount" :default="account" />
      <Emergency v-if="currentStep == 1" :handleCreate="handleCreateEmergency" :defaultValue="emergency" />
      <Quiz v-if="currentStep == 2" :role="role" :handleQuiz="handleQuiz" :defaultValue="quiz" />
      <Time v-if="currentStep == 3" :handleTime="handleSignUp" :defaultValue="times" />
      <Avatar v-if="currentStep == 4" :handleSign="handleURL" :defaultValue="url" />
    </a-spin>
  </Userlanding>
</template>
<script>
import { mapActions } from "vuex";
import Userlanding from "../../components/userlanding.vue";
import Account from '../../components/signUp/account';
import Emergency from '../../components/signUp/emergency.vue'
import Quiz from '../../components/signUp/quiz.vue'
import Time from '../../components/signUp/time.vue'
import Avatar from '../../components/signUp/avatar.vue'
import { createAccount, updateUser } from '../../api'
export default {
  components: {
    Userlanding, Account, Emergency, Quiz, Time, Avatar
  },
  data() {
    return {
      spin: false,
      currentStep: 0,
      user: undefined,
      emergency: undefined,
      quiz: undefined,
      times: undefined,
      role: undefined,
      account: undefined
    };
  },
  methods: {
    async handleCreateAccount(values) {
      this.account = values
      this.currentStep += 1
    },
    handleCreateEmergency(values) {
      this.emergency = values
      this.currentStep += 1
    },
    handleQuiz(values) {
      this.quiz = values
      this.currentStep += 1
    },
    async handleSignUp(values) {
      this.times = values
      try {
        this.spin = true
        this.user = await createAccount(this.account)

      } catch (e) {
        this.spin = false
        this.currentStep = 0
        return this.$notification.error({
          message: "Error happened",
          description: e.message,
        });
      }
      try {
        // request start here
        let req = {
          uid: this.user.uid,
          email: this.user.email,
          emergency: this.emergency,
          userInfo: {
            ...this.quiz,
            role: this.role,
            matched: 0,
            availability: this.times,
          }
        };

        await this.sign(req);
        this.spin = false
        this.currentStep += 1
      } catch (e) {
        this.spin = false
        return this.$notification.error({
          message: "Error happened",
          description: e.message,
        });
      }
    },
    async handleURL(url) {
      try {
        if (url) {
          this.spin = true
          await updateUser(this.user.uid, { avatar: url })
        }
        this.$router.push("/user/home");
        this.$message.success("welcome !");
      } catch (e) {
        this.spin = false
        return this.$notification.error({
          message: "Error happened",
          description: e.message,
        });
      }

    },
    ...mapActions({
      sign: "user/signUp",
    }),
  },
  mounted() {
    this.role = this.$route.params.role
  }
};
</script>

<style lang="less" scoped></style>
